import React from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"
import ProductType from "./ProductType"
import classNames from "classnames"
import {Tag} from "antd"
import moment from "moment"

BatchesRows.propTypes = {
    item: PropTypes.object,
    onChangeProductType: PropTypes.func.isRequired
}

function BatchesRows(props) {
    const {item, onChangeProductType, handleChangeInput} = props
    const {status, batch_id, item: order} = item
    const {partner, sewing_partner} = batch_id
    const {tags} = order

    const color = classNames({
        'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
        'printing progress-bar-animated progress-bar-striped': status === 'printing',
        'printed': status === 'printed',
        'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
        'transferred': status === 'transferred',
        'confirmed': status === 'confirmed',
        'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
        'sewing': status === 'sewing',
        'completed': status === 'completed' || status === 'done',
    })

    function _generateLevel(level) {
        const color = level === 3 ? 'rgb(255 45 0)' : level === 2 ? '#FFD300' : ''
        return (
            <div>
                <Tag
                    className={classNames(`tag-${level === 3 ? 'highest' : (level === 2 ? 'high' : 'medium')}`)}
                    color={color}
                >
                    {level !== undefined ? (level === 3 ? 'highest' : (level === 2 ? 'high' : 'medium')) : 'medium'}
                </Tag>
            </div>
        )
    }

    function _convertTime(stringDate) {
        return moment(stringDate).format("HH:mm DD/MM/YYYY")
    }

    function _handleChange() {
        const {item, onUpdateSelectedBatches} = props
        const isChecked = _detectChecked()

        onUpdateSelectedBatches(item._id, !isChecked, item._id)
    }

    function _detectChecked() {
        const {item, selectedBatchId} = props

        return selectedBatchId.includes(item._id)
    }

    function _convertErrorStyle(value) {
        switch (value) {
            case 'overview':
                return 'Toàn bộ'
            case 'detail':
                return 'Chi tiết'
            case 'print':
                return 'Lỗi in'
            case 'sewing':
                return 'Lỗi may'
            case 'press':
                return 'Lỗi ép'
            case 'fabric':
                return 'Lỗi vải'
            case 'cut':
                return 'Lỗi cắt'
            case 'billet':
                return 'Lỗi phôi'
            default:
                return ''

        }
    }

    const overtime = !!item.item && item.item.overtime
    const warningBatch = !!overtime && overtime >= -1.5
    const overtimed = !!warningBatch && overtime > 0
    const almostOvertime = !!warningBatch && !overtimed && !!overtime >= -1.5 && overtime < 0
    const wraningStyle = !!overtime ? { background: `rgb(${(!!almostOvertime ? "255, 208, 26, 0.3" : (overtimed ? "223, 31, 31, 0.2" : ''))})` } : {}
    const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
    const isTikTokTag = Array.isArray(tags) && tags.includes('tiktok')
    const is24hTag = Array.isArray(tags) && tags.includes('24h')
    const isGiftTag = Array.isArray(tags) && tags.includes('gift')
    const isSampleTag = Array.isArray(tags) && tags.includes('sample')
    const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
    const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
    const isUIDSAMPLETag = Array.isArray(tags) && tags.includes('UIDSAMPLE')
    const isCutOffTag = Array.isArray(tags) && tags.includes('cutoff')
    const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
    const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
    const isSLLTag = Array.isArray(tags) && tags.includes('SLL')

    return (
        <tr className={`BatchesRows ${!!tags && tags.includes('waiting-update-design') ? 'FalseDesign' : ''}`}
            key={item._id}
            style={wraningStyle}
            >
            <td className="BatchSelectedAll">
                <input
                    type="checkbox"
                    disabled={!!tags && tags.includes('waiting-update-design')}
                    checked={_detectChecked()}
                    onChange={_handleChange}
                />
            </td>
            <td className="BatchItem">
                {`#${item.item.marketplace}_${item.item.item_number}`}
            </td>
            <td className="BatchName">
                <Link to={`/batches/${item.batch_id._id}`}>
                    {item.batch_id.name}
                </Link>
                {
                    _generateLevel(item.batch_id.level_number)
                }
{   
                    isGiftTag && 
                    <div>
                        <Tag color="#6c757d">Hàng tặng</Tag>
                    </div>
                }

                {
                    isSampleTag && 
                    <div>
                        <Tag color="#6c757d">Hàng mẫu</Tag>
                    </div>
                }

                {
                    isFbaTag && 
                    <div>
                        <Tag color="#6c757d">FBA</Tag>
                    </div>
                }

                {
                    isFastShipTag && 
                    <div>
                        <Tag color="#6c757d">Ship nhanh</Tag>
                    </div>
                }

                {
                    isUIDSAMPLETag && 
                    <div>
                        <Tag color="#6c757d">UIDSAMPLE</Tag>
                    </div>
                }

                {
                    isFastProductionTag && 
                    <div>
                        <Tag color="#FFA500">Sản xuất nhanh</Tag>
                    </div>
                }

                {
                    isTikTokTag && 
                    <div>
                        <Tag color="#dc3644">TIKTOK</Tag>
                    </div>
                }

                {
                    is24hTag &&
                    <div>
                        <Tag color="#dc3644">24h</Tag>
                    </div>
                }

                {
                    isCutOffTag && 
                    <div>
                        <Tag color="#FF6600">cutoff</Tag>
                    </div>
                }

                {
                    isCutOffNoel &&
                    <div>
                        <Tag color="#FF6600">cutoff_noel</Tag>
                    </div>
                }

                {
                    isCutOffNewYear &&
                    <div>
                        <Tag color="#FF6600">cutoff_new_year</Tag>
                    </div>
                }

                {
                    isSLLTag &&
                    <div>
                        <Tag color="#fdb813">SLL</Tag>
                    </div>
                }
            </td>
            <td className="BatchCreated">{_convertTime(item.batch_id.created_at)}</td>
            <ProductType 
                types={[item.product_type]} 
                onChangeProductType={onChangeProductType} 
                brand={batch_id.brand} 
                handleChangeInput={handleChangeInput}
            />
            <td className="BatchStatus">
                <span className={`badge ${color} badge-pill`}>{status}</span>
            </td>
            <td className="BatchPartner">{_convertErrorStyle(item.error_type)}</td>
            <td className="BatchPartner">{!!partner ? partner.name : '-'}</td>
            <td className="BatchPartner">{!!sewing_partner ? sewing_partner.name : '-'}</td>
            <td className="BatchUserCreated">{item.batch_id.user_create}</td>
            <td className="BatchNote">{item.batch_id.note}</td>
        </tr>
    )
}

export default BatchesRows
